import SavedQuestion from "../../components/SavedQuestion";

const Saved = () => {
  return (
    <div>
      <SavedQuestion />
    </div>
  );
};

export default Saved;
